import { Paths } from "@constants/paths";
import { cn } from "kz-ui-sdk";
import { useNavigate } from "react-router-dom";
import { OnboardingDialogStep } from "../../constants";
import { OnboardingDialogProps } from "../../types";
import { DialogController } from "../DialogController/DialogController";
import { ForgotSecretStep, LegalNameStep, OnboardStep } from "./components";

const DialogUsernamePassword = ({
  isOpen,
  handleClose,
  stepNavigate,
  onboardingMode,
  step,
  callback,
  layout,
}: OnboardingDialogProps) => {
  const routerNavigate = useNavigate();

  return (
    <DialogController
      layout={layout}
      isOpen={isOpen}
      onClose={handleClose}
      classes={{
        drawer: {
          "container&": cn("!px-4 !pb-4"),
        },
      }}
    >
      {/*ONBOARDING STEP*/}
      {/* Mode = MemberSettingAuthMode.UsernamePassword 
        OnboardingStep include:
        - Login Username Password
        - Login Phone OTP
        - Register Username Password
      */}
      {step === OnboardingDialogStep.Onboarding && onboardingMode && (
        <OnboardStep
          defaultMode={onboardingMode}
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*FORGOT PASSWORD STEP*/}
      {step === OnboardingDialogStep.ForgotSecret && (
        <ForgotSecretStep
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*LEGAL NAME STEP*/}
      {[OnboardingDialogStep.UpdateLegalName, OnboardingDialogStep.AddLegalName].includes(step) && (
        <LegalNameStep
          navigate={stepNavigate}
          handleClose={handleClose}
          onUpdateSuccess={() => {
            if (callback) {
              callback();
            }
            routerNavigate(Paths.PRIVATE.HOME);
          }}
          layout={layout}
          step={step}
        />
      )}
    </DialogController>
  );
};

export default DialogUsernamePassword;
